// AUTO-GENERATED by scripts/sync-d1-family-children.mjs; do not edit.
// Source: business/ishvaram/data/governance/d1_family_children.json
//
// Indexed D1 child slugs per hub family. Bare slugs, no leading or trailing
// slash, exactly as the `pages` table stores them.

export const D1_FAMILY_CHILDREN = {
  "hi/graha": [
    "hi/graha/jupiter/in-10-house",
    "hi/graha/jupiter/in-5-house",
    "hi/graha/jupiter/in-kark",
    "hi/graha/jupiter/in-mithun",
    "hi/graha/ketu/in-10-house",
    "hi/graha/ketu/in-12-house",
    "hi/graha/ketu/in-2-house",
  ],
  "hi/yoga": [
    "hi/yoga/adhi-yoga",
    "hi/yoga/anapha",
    "hi/yoga/chandra-mangal",
    "hi/yoga/dhana-yoga",
    "hi/yoga/kahala-yoga",
    "hi/yoga/malavya",
    "hi/yoga/neecha-bhanga-raja-yoga",
    "hi/yoga/papa-kartari",
    "hi/yoga/raja-yoga",
    "hi/yoga/sankha-yoga",
    "hi/yoga/shakata",
  ],
  "hi/mahadasha": [
    "hi/mahadasha/jupiter/jupiter-antardasha",
    "hi/mahadasha/ketu/mars-antardasha",
    "hi/mahadasha/ketu/mercury-antardasha",
    "hi/mahadasha/ketu/moon-antardasha",
    "hi/mahadasha/ketu/sun-antardasha",
    "hi/mahadasha/ketu/venus-antardasha",
    "hi/mahadasha/mars/sun-antardasha",
    "hi/mahadasha/mars/venus-antardasha",
    "hi/mahadasha/mercury/jupiter-antardasha",
    "hi/mahadasha/mercury/ketu-antardasha",
    "hi/mahadasha/mercury/mars-antardasha",
    "hi/mahadasha/mercury/moon-antardasha",
    "hi/mahadasha/mercury/rahu-antardasha",
    "hi/mahadasha/mercury/saturn-antardasha",
    "hi/mahadasha/moon/jupiter-antardasha",
    "hi/mahadasha/moon/moon-antardasha",
    "hi/mahadasha/moon/rahu-antardasha",
    "hi/mahadasha/moon/saturn-antardasha",
    "hi/mahadasha/moon/sun-antardasha",
    "hi/mahadasha/moon/venus-antardasha",
    "hi/mahadasha/rahu/ketu-antardasha",
    "hi/mahadasha/rahu/mercury-antardasha",
    "hi/mahadasha/rahu/rahu-antardasha",
    "hi/mahadasha/saturn/mars-antardasha",
    "hi/mahadasha/saturn/mercury-antardasha",
    "hi/mahadasha/saturn/rahu-antardasha",
    "hi/mahadasha/sun/ketu-antardasha",
    "hi/mahadasha/sun/mercury-antardasha",
    "hi/mahadasha/sun/rahu-antardasha",
    "hi/mahadasha/sun/sun-antardasha",
    "hi/mahadasha/venus/mercury-antardasha",
    "hi/mahadasha/venus/moon-antardasha",
    "hi/mahadasha/venus/saturn-antardasha",
  ],
} as const satisfies Readonly<Record<string, readonly string[]>>;

export type D1ChildFamily = keyof typeof D1_FAMILY_CHILDREN;
